import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { InputDecimal } from "@/components/ui/input-decimal";
import { Label } from "@/components/ui/label";

import { apagarSaldo, gravarSaldo, mensagemDeErro } from "../api";
import { hojeIso } from "../lib/periodos";

/** Quanto a loja tinha na conta (banco + gaveta) no fim de um dia. É o ponto de
 *  partida do saldo; sem ele o fluxo mostra só o resultado acumulado. */
export default function SaldoContaDialog({ aberto, setAberto, base, aoSalvar }) {
  const [valor, setValor] = useState(base ? String(base.valor) : "");
  const [data, setData] = useState(base?.data || hojeIso());
  const [negativo, setNegativo] = useState(base ? base.valor < 0 : false);
  const [salvando, setSalvando] = useState(false);

  const salvar = async () => {
    setSalvando(true);
    try {
      await gravarSaldo((Number(valor) || 0) * (negativo ? -1 : 1), data);
      toast.success("Saldo da conta salvo"); setAberto(false); aoSalvar();
    } catch (e) { toast.error(mensagemDeErro(e, "Não consegui salvar o saldo.")); } finally { setSalvando(false); }
  };
  const remover = async () => { await apagarSaldo(); toast.success("Saldo removido"); setAberto(false); aoSalvar(); };

  return (
    <Dialog open={aberto} onOpenChange={setAberto}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Saldo da conta</DialogTitle>
          <DialogDescription>Quanto a loja tinha no fim de um dia — some banco e dinheiro guardado. O fluxo parte desse número.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Saldo</Label>
            <div className="mt-1 flex items-center gap-2">
              <button type="button" onClick={() => setNegativo((v) => !v)} className={`h-10 w-10 rounded-md border font-bold ${negativo ? "text-red-600 border-red-500/40 bg-red-500/10" : ""}`} title="Saldo negativo?">{negativo ? "−" : "+"}</button>
              <span className="text-muted-foreground text-sm">R$</span>
              <div className="flex-1"><InputDecimal decimals={2} value={valor} onChange={setValor} data-e2e="campo-saldo" /></div>
            </div>
          </div>
          <div>
            <Label>No fim do dia</Label>
            <Input type="date" max={hojeIso()} value={data} onChange={(e) => setData(e.target.value)} className="mt-1" />
          </div>
          <div className="flex gap-2 pt-1">
            {base && <Button variant="outline" className="text-destructive" onClick={remover}>Remover</Button>}
            <Button className="flex-1" onClick={salvar} disabled={salvando} data-e2e="salvar-saldo">{salvando ? "Salvando…" : "Salvar saldo"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
